<template>
  <v-dialog :value="showDialog" @input="cancel()" width="600">
    <v-card id="informPendingRates">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          resx.labels.notification.toUpperCase()
        }}</v-toolbar-title>
      </v-app-bar>
      <v-card-text class="mt-4 pl-5">
        {{ resx.labels.youHavePendingRates }}
      </v-card-text>
      <v-card-actions class="mr-4 pb-4">
        <v-spacer />
        <v-btn color="success" @click="openPendingRates()">
          {{ resx.labels.qualifyVisits.toUpperCase() }}
        </v-btn>
        <v-btn v-if="logout" color="error" @click="closeSystem()">
          {{ resx.labels.closeSystem.toUpperCase() }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "informPendingRates",
  components: {},
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    cancel() {
      this.showDialog = false;
      this.$emit("cancel");
    },
    openPendingRates() {
      this.showDialog = false;
      this.$emit("openPendingRates");
    },
    closeSystem() {
      this.showDialog = false;
      this.$emit("close");
    }
  },
  props: {
    show: { type: Boolean },
    logout: { type: Boolean, default: false }
  },
  watch: {
    show: {
      handler: function(val) {
        this.showDialog = val != null;
      },
      immediate: true
    }
  }
};
</script>
